var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TwoItemField"},[_c('div',{staticClass:"item"},[_vm._v("\n    "+_vm._s(_vm.dataInfo.leftLabel)+"\n\n    "+_vm._s(_vm.moneyFormat(
      _vm.pageData[_vm.dataInfo.leftKey], 
      _vm.dataInfo.leftMoneyFormat
    ))+"\n\n    "+_vm._s(_vm.dataInfo.leftCompany)+"\n  ")]),_c('div',[_vm._v("\n    "+_vm._s(_vm.dataInfo.rightLabel)+"\n\n    "+_vm._s(_vm.moneyFormat(
      _vm.pageData[_vm.dataInfo.rightKey], 
      _vm.dataInfo.rightMoneyFormat
    ))+"\n\n    "+_vm._s(_vm.dataInfo.rightCompany)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }